// サンクスページ以外で作動させる
if (!window.location.pathname.includes('/thanks')) {
  // spモードのときだけ、トップからスクロールしたら、jsContactButton idのdisplayをblockにする
  window.addEventListener('scroll', () => {
    if (window.scrollY > 100 && isSpMode()) {
        const conversationButton = document.getElementById('jsContactButton') as HTMLElement
        // バーガーメニューが開いていなかったら
        if (!conversationButton.classList.contains('-active')) {
            conversationButton.style.display = 'block'
        }
    } else {
        const conversationButton = document.getElementById('jsContactButton') as HTMLElement
        conversationButton.style.display = 'none'
    }
  })
}

// spモードの判定
const isSpMode = (): boolean => {
  // ウィンドウの幅が480px以下ならtrueを返す
  return window.innerWidth <= 480
}